export function getCookie(name) {
    let  v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

export function getUtmData() {
    let utm_source_storage = localStorage.getItem('utm_source');
    let utm_medium_storage = localStorage.getItem('utm_medium');
    let utm_campaign_storage = localStorage.getItem('utm_campaign');
    let utm_term_storage = localStorage.getItem('utm_term');
    let utm_content_storage = localStorage.getItem('utm_content');

    return {
        utm_source: utm_source_storage !== null ? utm_source_storage: '',
        utm_medium: utm_medium_storage !== null ? utm_medium_storage: '',
        utm_campaign: utm_campaign_storage !== null ? utm_campaign_storage: '',
        utm_term: utm_term_storage !== null ? utm_term_storage: '',
        utm_content: utm_content_storage !== null ? utm_content_storage: '',
    }
}

export function toCOP(number){
    if (typeof number === 'number') {
        return number.toLocaleString('es-CO', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    }
    else {
        return number;
    }
}
